module.exports = __webpack_public_path__ + "img/food-18.12ea6e1a.jpg";